import Navbar from './Navbar';
import Sidebar from './Sidebar';

export default function AppLayout({ children }) {
  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh', background: '#eef0f7' }}>
      <Navbar />
      <div className="d-flex flex-grow-1 align-items-start">
        <Sidebar />
        <main className="flex-grow-1 overflow-auto" style={{ padding: '1.25rem 1.5rem 1.5rem 1.25rem', minWidth: 0 }}>
          {children}
        </main>
      </div>
    </div>
  );
}
